export const FIELD = {
  ADDRESS_1: 'address_1',
  BIRTHDAY: 'birthday',
  COUNTRY: 'country',
  COUNTRY_CALLING_CODE: 'country_calling_code',
  CUSTOM_DATA: 'custom_data',
  DELIVERY_ADDRESSES: 'delivery_addresses',
  EMAIL: 'email',
  EXCLUDE_SMS_PLATFORM: 'exclude_sms_platform',
  GENDER: 'gender',
  IS_EMAIL_CONFIRMED: 'is_email_confirmed',
  MOBILE_PHONE: 'mobile_phone',
  NAME: 'name',
  IS_MOBILE_PHONE_CONFIRMED: 'is_mobile_phone_confirmed',
  PHONE: 'phone',
  PHONE_COUNTRY_CODE: 'phone_country_code',
  RECIPIENT_NAME: 'recipient_name',
  RECIPIENT_PHONE: 'recipient_phone',
  RECIPIENT_PHONE_COUNTRY_CODE: 'recipient_phone_country_code',
  SUBSCRIBED_EMAIL_TYPES: 'subscribed_email_types',
  TIME_ZONE_OFFSET: 'time_zone_offset',
  UNCONFIRMED_EMAIL: 'unconfirmed_email',
};

export const GENDER_FIELD_VALUE = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
};

export const MOBILE_RELATIVE_FIELDS = [
  FIELD.MOBILE_PHONE,
  FIELD.COUNTRY_CALLING_CODE,
  FIELD.IS_MOBILE_PHONE_CONFIRMED,
];

export const PHONE_RELATIVE_FIELDS = [FIELD.PHONE, FIELD.PHONE_COUNTRY_CODE];

export const RECIPIENT_RELATIVE_FIELDS = [
  FIELD.RECIPIENT_NAME,
  FIELD.RECIPIENT_PHONE,
  FIELD.RECIPIENT_PHONE_COUNTRY_CODE,
];
